import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SkupremeModal } from '../../components';
import { HoverBorderButton, MuteText, StyledButton, StyledInput } from '../../elements';
import { WaveRuleSearchInput } from './rule-search';
import { ToastMessage, WaveService } from '../../utility';

export function CreateWavePopup({ warehouseId, open, onClose, refresh }) {
  const [waveNumberLoading, setWaveNumberLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [formValue, setFormValues] = useState({
    waveNumber: '',
    waveRuleId: '',
  });

  const setValue = (key, value) => {
    setFormValues({
      ...formValue,
      [key]: value,
    });
  };

  const getNewWaveNumber = async () => {
    try {
      setWaveNumberLoading(true);
      const res = await WaveService.generateWaveNumber({ warehouseId });
      setValue('waveNumber', res?.waveNumber);
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setWaveNumberLoading(false);
    }
  };

  useEffect(() => {
    if (warehouseId && open) {
      getNewWaveNumber();
    } else {
      setFormValues({
        waveNumber: '',
        waveRuleId: '',
      });
    }
  }, [warehouseId, open]);

  const createWave = async () => {
    if (!formValue.waveRuleId._id) {
      ToastMessage.error('Please select a wave rule');
      return;
    }

    if (!formValue.waveNumber) {
      ToastMessage.error('Please enter a wave number');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        warehouseId,
        waveNumber: formValue.waveNumber,
        waveRuleId: formValue.waveRuleId._id,
      };
      await WaveService.createManualWave({ warehouseId }, payload);
      navigate('/app/fulfill/waves/list/building');
      ToastMessage.success('Wave created successfully');
      onClose();
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal open={open} title="Create a Manual Wave" size="tiny" onClose={onClose}>
      <div className="d-flex flex-column">
        <MuteText>Wave Number</MuteText>
        <StyledInput
          value={formValue.waveNumber}
          onChange={e => setValue('waveNumber', e.target.value)}
          placeholder="Wave Number"
          loading={waveNumberLoading}
        />
      </div>
      <div className="d-flex flex-column mt-2 mb-4">
        <MuteText>Wave Rule</MuteText>
        <WaveRuleSearchInput
          onResultClick={rule => setValue('waveRuleId', rule)}
          warehouseId={warehouseId}
        />
        {formValue?.waveRuleId?.name && (
          <span>
            {formValue?.waveRuleId?.name}
            <MuteText> - Selected</MuteText>
          </span>
        )}
      </div>
      <div className="d-flex justify-content-end">
        <HoverBorderButton onClick={onClose} disabled={loading}>
          Cancel
        </HoverBorderButton>
        <StyledButton loading={loading} className="ml-2" onClick={createWave}>
          Create
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
